<template>
  <v-card :height="gridHeight" elevation="0">
    <div id="GridParent" style="height: 100%">
      <ejs-grid
        ref="agendaViewGrid"
        :load="load"
        :frozenColumns="3"
        :dataSource="dataSource"
        :dataBound="dataBound"
        :beforeDataBound="beforeDataBound"
        :enableAdaptiveUI="false"
        height="100%"
        :allowSelection="false"
        :allowResizing="true"
        :allowSorting="true"
        :allowMultiSorting="false"
        :enableHover="false"
        :sortSettings="sortingOptions"
        width="100%"
        gridLines="Both"
        :allowTextWrap="true"
        :textWrapSettings="wrapSettings"
        :columns="columns"
        :queryCellInfo="queryCellInfoEvent"
        :actionBegin="actionBegin"
        :actionComplete="actionComplete"
      >
      </ejs-grid>
    </div>
    <Loader :loading="Loaderloading" :message="LoaderText"></Loader>
  </v-card>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import {
  GridPlugin,
  Freeze,
  Resize,
  Sort,
  Page,
  Search,
} from "@syncfusion/ej2-vue-grids";
import AgendaViewGridRowTemplateVue from "./AgendaViewGridRowTemplate.vue";
import customFunctions from "@/codeFiles/taskHelper.js";
import AgendaViewGridMeetingRowTemplateVue from "./AgendaViewGridMeetingRowTemplate.vue";
import TopicCategoryHeaderTemplate from "./topicCategoryHeaderTemplate.vue";
import StackedColumnTemplate from "./StackedColumnTemplate.vue";
import AgendaFrozenHeaderTemplate from "./AgendaFrozenHeaderTemplate.vue";
import Loader from "@/components/Loader.vue";
import AgendaViewMeetingTypeColumn from "./AgendaViewMeetingTypeColumn";
Vue.use(GridPlugin);
Vue.prototype.$eventHub = new Vue();
export default {
  name: "AgendaViewGrid",
  provide: {
    grid: [Freeze, Resize, Sort, Page, Search],
  },
  components: {
    AgendaViewGridRowTemplateVue,
    AgendaViewGridMeetingRowTemplateVue,
    AgendaViewMeetingTypeColumn,
    Loader,
  },
  props: {
    gridData: Array,
    gridHeight: Number,
    searchText: String,
  },
  data() {
    return {
      dataSource: [],
      Loaderloading: false,
      topicCategories: [],
      gridReady: false,
      meetingTypeColTemplate: () => {
        return () => {
          return {
            template: {
              parent: this,
              extends: AgendaViewMeetingTypeColumn,
              data() {
                return {
                  data: {},
                };
              },
              propsData: {},
            },
          };
        };
      },
      wrapSettings: { wrapMode: "Content" },

      rowTemplate: (column) => {
        return () => {
          return {
            template: {
              parent: this,
              extends: AgendaViewGridRowTemplateVue,
              data() {
                return {
                  data: {},
                };
              },
              propsData: { column: column },
            },
          };
        };
      },
      meetingTitleRowTemplate: () => {
        return () => {
          return {
            template: {
              parent: this,
              extends: AgendaViewGridMeetingRowTemplateVue,
              data() {
                return {
                  data: {},
                };
              },
              propsData: {},
            },
          };
        };
      },
      topicCategoryHeaderTemplate: function (topicCategory) {
        return () => {
          return {
            template: {
              extends: TopicCategoryHeaderTemplate,
              data() {
                return {
                  data: {},
                };
              },
              propsData: { category: topicCategory },
            },
          };
        };
      },
      stackedColumn: function (title, sequence) {
        return () => {
          return {
            template: {
              extends: StackedColumnTemplate,
              data() {
                return {
                  data: {},
                };
              },
              propsData: { title: title, sequence: sequence },
            },
          };
        };
      },
      AgendaFrozenHeaderTemplate: function () {
        return () => {
          return {
            template: {
              extends: AgendaFrozenHeaderTemplate,
              data() {
                return {
                  data: {},
                };
              },
              propsData: {
                sortOptions: this.sortingOptions,
              },
            },
          };
        };
      },
    };
  },
  computed: {
    ...gettersMap(),
    LoaderText() {
      return this.$t("LoaderText");
    },
    columns() {
      let firstCol = [
        {
          field: "meetingName",
          headerText: this.$t("agenda.lblMeetingType"),
          template: this.meetingTypeColTemplate(),
          width: 107,
          allowResizing: false,
          visible: false,
        },
        {
          field: "scheduledEndTimeInUTC",
          headerText: this.$t("meetings"),
          visible: false,
          allowSorting: true,
        },
        {
          field: "email",
          headerText: this.$t("meetings"),
          headerTemplate: this.AgendaFrozenHeaderTemplate(),
          template: this.meetingTitleRowTemplate(),
          width: 400,
          allowSorting: false,
        },
      ];
      this.topicCategories.forEach((cat, inc) => {
        firstCol.push({
          field: "topic_category",
          template: this.meetingTitleRowTemplate(),
          headerTemplate: this.stackedColumn(
            this.$t("agenda.hTopicCategory"),
            inc
          ),
          width: 250,
          allowSorting: false,
          columns: [
            {
              field: cat.value,
              template: this.rowTemplate(cat),
              headerTemplate: this.topicCategoryHeaderTemplate(cat),
              width: 250,
              allowSorting: false,
            },
          ],
        });
      });
      // Avoid mutating reactive data inside computed (side-effect) – watcher will update dataSource
      return firstCol;
    },
    sortingOptions() {
      let sortOptions = {
        columns: [{ field: "scheduledEndTimeInUTC", direction: "" }],
      };
      sortOptions.columns.forEach((element) => {
        element.direction = this.isMeetingTypeFilterForPast(this.getFilterData.filter_type) ? "Descending" : "Ascending";
      });
      return sortOptions;
    }
  },
  created() {
    this.topicCategories = this.tenantSettingTypes("topiccategory").sort(
      (a, b) => a.order - b.order
    );
  },

  mounted() {
    this.$root.$on("agendaGridSorting", (params) => {
      this.agnedaGridSorting(params);
    });
    //this.Loaderloading = true;
    this.gridReady = true;
    // initialize data source after grid is ready
    this.dataSource = Array.isArray(this.gridData) ? this.gridData : [];
  },
  beforeDestroy() {
    this.$root.$off("agendaGridSorting");
  },
  watch: {
    searchText() {
      this.$refs.agendaViewGrid.search(this.searchText);
    },
    gridData: {
      immediate: true,
      handler(newVal) {
        if (!this.gridReady) return;
        this.dataSource = Array.isArray(newVal) ? newVal : [];
      },
    },
  },

  methods: {
    queryCellInfoEvent,
    getTextColor,
    dataBound,
    handleXScroll,
    handleYScroll,
    load,
    isMeetingTypeFilterForPast(filter_type) {
      if(filter_type == "month" || filter_type == "quarter" || filter_type == "year" || filter_type == "custom") {
        return true;
      }
      else {
        return false;
      }
    },
    agnedaGridSorting(params) {
      if (params.direction) {
        this.$refs.agendaViewGrid.ej2Instances.sortColumn(
          params.column,
          params.direction,
          false
        );
      }
    },
    beforeDataBound: function (args) {
      //this.Loaderloading = true;
      this.loaderStart();
    },

    actionBegin(args) {
      this.loaderStart();
    },
    async actionComplete(args) {
      await this.loaderStop();
    },

    async sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    loaderStart() {
      this.Loaderloading = true;
      if (
        this.$refs.agendaViewGrid &&
        this.$refs.agendaViewGrid.$el.classList
      ) {
        this.$refs.agendaViewGrid.$el.classList.add("disablegrid");
        let gridElement = document.getElementById("GridParent");
        if (gridElement.classList) {
          gridElement.classList.add("wrapper");
        }
      }
    },
    async loaderStop() {
      await this.sleep(2000);
      if (
        this.$refs.agendaViewGrid &&
        this.$refs.agendaViewGrid.$el.classList &&
        this.$refs.agendaViewGrid.$el.classList.contains("disablegrid")
      ) {
        this.$refs.agendaViewGrid.$el.classList.remove("disablegrid");
        let gridElement = document.getElementById("GridParent");
        if (gridElement.classList) {
          gridElement.classList.remove("wrapper");
        }
      }
      this.Loaderloading = false;
    },
  },
};

function load() {
  this.$refs.agendaViewGrid.ej2Instances.defaultLocale.EmptyRecord = "";
}
function dataBound() {
  if (!this.$refs.agendaViewGrid) return;
  const content = this.$refs.agendaViewGrid.getContent && this.$refs.agendaViewGrid.getContent();
  if (!content) return;
  const bottomScrollBar = content.querySelector(".e-movablecontent");
  if (bottomScrollBar) {
    bottomScrollBar.removeEventListener("scroll", this.handleXScroll);
    bottomScrollBar.addEventListener("scroll", this.handleXScroll, { passive: true });
  }
  const verticalScrollBar = content.querySelector(".e-content");
  if (verticalScrollBar) {
    verticalScrollBar.removeEventListener("scroll", this.handleYScroll);
    verticalScrollBar.addEventListener("scroll", this.handleYScroll, { passive: true });
  }
  //this.Loaderloading = false;
  this.loaderStop();
}

function handleXScroll(event) {
  if (!this.$refs.agendaViewGrid) return;
  const content = this.$refs.agendaViewGrid.getContent && this.$refs.agendaViewGrid.getContent();
  if (!content) return;
  const bottomScrollBar = content.querySelector(".e-movablecontent");
  if (!bottomScrollBar) return;
  const width = bottomScrollBar.scrollLeft;

  this.$store.commit("StoreAgendaGridWidth", width);
}

function handleYScroll(event) {
  if (!this.$refs.agendaViewGrid) return;
  const content = this.$refs.agendaViewGrid.getContent && this.$refs.agendaViewGrid.getContent();
  if (!content) return;
  const verticalScrollBar = content.querySelector(".e-content");
  if (!verticalScrollBar) return;
  const height = verticalScrollBar.scrollTop;

  this.$store.commit("StoreAgendaGridHeight", height);
  // console.log(height);
}

function gettersMap() {
  return mapGetters({
    tenantSettingTypes: "tenant/tenantSettingTypes",
    getFilterData: "meeting/getFilterData",
  });
}

function queryCellInfoEvent(args) {
  args.cell.style.verticalAlign = "top";
  let col = args.column.field;
  if (
    col === "meetingName" ||
    col === "scheduledEndTimeInUTC" ||
    col === "scheduledTimeInUTC"
  ) {
    args.cell.style.backgroundColor = "var(--v-Neutral-lighten3)";
  } else {
    const topics = args.data.topics.filter((t) => t.topicCategory === col);
    if (topics.length > 0) {
      args.cell.style = `vertical-align: top;`;
      args.cell.style.backgroundColor = "var(--v-Neutral-base)";
    } else {
      args.cell.style.backgroundColor = "var(--v-Neutral-base)";
    }
  }
}

function getTextColor(color) {
  return customFunctions.getContrast(color) ? "white" : "black";
}
</script>

<style scoped>
::v-deep .disablegrid {
  pointer-events: none;
  opacity: 0.9;
}
::v-deep #GridParent .e-grid .e-movableheader .e-headercell {
  height: 30px;
  background-color: var(--v-secondary-base);
  border-left: 1px solid var(--v-secondary-darken1);
  color: var(--v-darkCharcoal-base) !important;
}
::v-deep #GridParent .e-grid .e-headercelldiv,
::v-deep #GridParent .e-grid .e-stackedheadercelldiv {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 700 !important;
  font-size: 15px !important;
}

::v-deep #GridParent .e-grid .e-gridheader {
  background-color: var(--v-secondary-base);
}

::v-deep #GridParent .e-grid .e-frozenheader {
  background-color: var(--v-neutralGray-base) !important;
}
::v-deep #GridParent .e-grid .e-frozenheader .e-sortfilterdiv {
  display: none !important;
  height: 0px;
  width: 0px;
}
::v-deep #GridParent .e-grid .e-gridheader .e-frozenheader .e-headercell {
  background-color: var(--v-neutralGray-base) !important;
  color: var(--v-secondary-lighten2) !important;
}

::v-deep #GridParent .e-grid .e-gridheader .e-frozenheader .e-headercelldiv {
  padding: 0px !important;
}

::v-deep #GridParent .e-grid .e-movablecontent .e-rowcell {
  padding: 8px;
}
::v-deep #GridParent .e-grid .e-frozencontent td.e-rowcell {
  padding: 0px !important;
}
.e-grid .e-content.c-scroll {
  overflow-y: auto;
}

::v-deep #GridParent .e-table,
.e-grid .e-frozencontent .e-virtualtable > .e-table,
#GridParent .e-grid .e-frozenheader .e-virtualtable > .e-table {
  border-right-color: var(--v-secondary-base) !important;
}

.e-grid .e-frozencontent td.e-rowcell {
  background-color: var(--v-Natural-lighten4) !important;
}
::v-deep #GridParent .e-grid .e-movablecontent {
  background-color: var(--v-Neutral-base) !important;
}
::v-deep .e-spinner-pane {
  animation: material-spinner-rotate 1568.63ms linear infinite;
  display: None;
  margin: 0 auto;
}
::v-deep .e-spinner-pane .e-spinner-inner .e-spin-material {
  animation: material-spinner-rotate 1568.63ms linear infinite;
  display: None;
  margin: 0 auto;
}
::v-deep .agenda-card {
  background: #ffffff;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1) !important;
  border-radius: 4px;
}
::v-deep .agenda-card .text-subtitle-1 {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
}

::v-deep .agenda-card .v-card__text {
  padding: 12px !important;
  color: var(--v-darkCharcoal-base) !important;
}
::v-deep .agenda-card .text--topic {
  font-family: "Noto Sans JP";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  /* color: var(--v-darkCharcoal-base); */
}

::v-deep .agenda-card .topic-grid-display {
  display: grid;
  grid-gap: 14px;
}

::v-deep .card-grid-display {
  display: grid;
  grid-gap: 8px;
}
::v-deep .e-grid .e-gridheader table th[rowspan],
::v-deep .e-grid.e-device .e-gridheader table th[rowspan] {
  vertical-align: middle !important;
}
::v-deep .e-columnheader:has(.e-stackedheadercell) th.e-stackedheadercell {
  background-color: var(--v-neutralGray-base) !important;
}
::v-deep #GridParent .e-grid .e-stackedheadercell {
  border-left: none !important;
}
::v-deep .e-grid .e-gridheader table th[rowspan],
.e-grid.e-device .e-gridheader table th[rowspan] {
  padding-bottom: 0 !important;
}
</style>